import axios from 'axios'

axios.defaults.baseURL = 'http://127.0.0.1:8094/touhou-api/'
// axios.defaults.baseURL = 'https://www.aslucky.club/touhou-api/'

axios.defaults.localURL = `http://127.0.0.1:8030/`

axios.defaults.fileURL = `${document.location.origin}/file/`
axios.defaults.baseURL = `${document.location.origin}/touhou-api/`

// if (document.location.origin.indexOf('localhost') > -1) {
    axios.defaults.fileURL = `https://www.aslucky.club/file/`
    axios.defaults.baseURL = `https://www.aslucky.club/touhou-api/`
// }

axios.interceptors.request.use((config) => {
    config.headers['region'] = localStorage.getItem('region') || '0'
    config.headers['aaa'] = localStorage.getItem('aaa') || '0'
    config.headers['handleStr'] = localStorage.getItem('handleStr') || ''
    return config
})

axios.interceptors.response.use((res) => {
    let data = res.data

    if (data.code === undefined) {
        return data
    }

    if (data.code < 0) {

    }

    return data.data
})

export default axios
